document.addEventListener("DOMContentLoaded", () => {
  initMegaMenus();
  initHeaderDrawer();
  initSubmenuNavigation();
});

function initMegaMenus() {
  document.querySelectorAll(".mega__menu").forEach((menu) => {
    const childItems = [...menu.querySelectorAll("[mega__child-li]")];
    const grandWrappers = [...menu.querySelectorAll(".mega__grand-wrapper")];

    const firstMatch = findFirstMatch(childItems, grandWrappers);
    if (firstMatch) setActive(firstMatch.child, firstMatch.wrapper);

    childItems.forEach((child) =>
      child.addEventListener("mouseenter", () =>
        handleMouseEnter(child, childItems, grandWrappers)
      )
    );
  });
}

function findFirstMatch(childItems, grandWrappers) {
  return (
    childItems
      .map((child) => ({
        child,
        wrapper: grandWrappers.find(
          (wrapper) =>
            wrapper.getAttribute("data-child") ===
            child.getAttribute("data-child")
        ),
      }))
      .find((match) => match.wrapper) || null
  );
}

function setActive(child, wrapper) {
  child?.classList.add("active");
  wrapper?.classList.add("active");
}

function removeActive(childItems, grandWrappers) {
  childItems.forEach((item) => item.classList.remove("active"));
  grandWrappers.forEach((wrapper) => wrapper.classList.remove("active"));
}

function handleMouseEnter(child, childItems, grandWrappers) {
  removeActive(childItems, grandWrappers);
  const matchedWrapper = grandWrappers.find(
    (wrapper) =>
      wrapper.getAttribute("data-child") === child.getAttribute("data-child")
  );
  if (matchedWrapper) setActive(child, matchedWrapper);
}

function initHeaderDrawer() {
  const drawer = document.querySelector(".header__drawer");
  const opener = document.querySelector("[header-drawer-opener]");
  const closer = document.querySelector("[header-drawer-close]");
  if (!drawer || !opener || !closer) return;
  const setOpen = (open, restoreFocus = true) => {
    drawer.classList.toggle("active", open);
    drawer.inert = !open;
    drawer.setAttribute("aria-hidden", String(!open));
    opener.setAttribute("aria-expanded", String(open));
    document.documentElement.classList.toggle("overflow-hidden", open);
    document.body.classList.toggle("overflow-hidden", open);
    if (open) closer.focus();
    else if (restoreFocus && opener.getClientRects().length) opener.focus();
  };
  opener.addEventListener("click", () => setOpen(!drawer.classList.contains("active")));
  closer.addEventListener("click", () => setOpen(false));
  document.addEventListener("click", (event) => {
    if (drawer.classList.contains("active") && !drawer.contains(event.target) && !opener.contains(event.target)) setOpen(false);
  });
  drawer.addEventListener("keydown", (event) => {
    if (!drawer.classList.contains("active")) return;
    if (event.key === "Escape") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Tab") {
      const focusable = [...drawer.querySelectorAll('a[href], button, summary, input, select, textarea, [tabindex="0"]')]
        .filter((item) => !item.disabled && item.getClientRects().length && !item.closest('[inert]'));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first) { event.preventDefault(); drawer.focus(); }
      else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  window.matchMedia("(min-width: 1250px)").addEventListener("change", (event) => {
    if (event.matches) setOpen(false, false);
  });
}

function initSubmenuNavigation() {
  const openButtons = document.querySelectorAll(".open-submenu");
  const backButtons = document.querySelectorAll(".back-button");
  const grandchildToggles = document.querySelectorAll(".toggle-grandchild");
  let openGrandchildMenu = null;

  openButtons.forEach((button) =>
    button.addEventListener("click", () => {
      const submenu = button.closest("li").querySelector(".submenu");
      submenu?.classList.add("active");
    })
  );

  backButtons.forEach((button) =>
    button.addEventListener("click", () => {
      const submenu = button.closest(".submenu");
      submenu?.classList.remove("active");
    })
  );

  grandchildToggles.forEach((toggle) =>
    toggle.addEventListener("click", () => {
      const grandchildMenu = toggle
        .closest(".submenu-item")
        .querySelector(".grandchild-menu");
      const subMenuItem = grandchildMenu?.closest(".has-grandchildren");

      if (grandchildMenu) {
        if (openGrandchildMenu && openGrandchildMenu !== grandchildMenu) {
          openGrandchildMenu.style.height = "0px";
          openGrandchildMenu.classList.remove("open");

          // Remove open class from previously opened parent .has-grandchildren
          const previousSubMenuItem =
            openGrandchildMenu.closest(".has-grandchildren");
          previousSubMenuItem?.classList.remove("open");
        }

        if (grandchildMenu.classList.contains("open")) {
          grandchildMenu.style.height = "0px";
          grandchildMenu.classList.remove("open");

          // Remove open class from the closest .has-grandchildren
          subMenuItem?.classList.remove("open");

          openGrandchildMenu = null;
        } else {
          grandchildMenu.style.height = `${grandchildMenu.scrollHeight}px`;
          grandchildMenu.classList.add("open");

          // Add open class to the closest .has-grandchildren
          subMenuItem?.classList.add("open");

          openGrandchildMenu = grandchildMenu;
        }
      }
    })
  );
}

function setupFixedHeader(isSticky) {
  const mainHeader = document.querySelector(".site__header");
  if (!mainHeader) return;

  if (!isSticky) return;

  const headerSection = mainHeader.closest(".shopify-section");
  if (!headerSection) return;

  function adjustFixedPosition() {
    if (window.scrollY > 300) {
      headerSection.classList.remove("not__fixed");
      headerSection.classList.add("fixed__header");
    } else {
      headerSection.classList.add("not__fixed");
      headerSection.classList.remove("fixed__header");
    }
  }

  adjustFixedPosition();
  window.addEventListener("scroll", adjustFixedPosition);
  window.addEventListener("resize", adjustFixedPosition);
}

document.addEventListener("DOMContentLoaded", function () {
  const drawerLogo = document.querySelector(".drawer__logo");
  const drawerMenu = document.querySelector(".drawer-menu");
  const drawerUtensils = document.querySelector(".drawer__utensils");
  const submenus = document.querySelectorAll(".submenu");
  const siteHeader = document.querySelector(".site__header");
  if (siteHeader) {
    const isSticky = siteHeader.dataset.sticky === "true";
    setupFixedHeader(isSticky);
  }

  if (drawerLogo && drawerMenu && drawerUtensils) {
    const logoHeight = drawerLogo.offsetHeight;
    const utensilsHeight = drawerUtensils.offsetHeight;
    drawerMenu.style.height = `calc(100% - ${logoHeight + utensilsHeight}px)`;
  }

  if (drawerLogo && submenus.length > 0) {
    const logoHeight = drawerLogo.offsetHeight;
    submenus.forEach((submenu) => {
      submenu.style.top = `${logoHeight}px`;
      submenu.style.height = `calc(100% - ${logoHeight}px)`;
    });
  }
});
